import React from "react";
import styles from "./unlink-confirm-modal.module.scss";

interface UnlinkConfirmModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isLoading?: boolean;
}

export const UnlinkConfirmModal: React.FC<UnlinkConfirmModalProps> = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
	if (!isOpen) return null;

	const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget && !isLoading) onClose();
	};

	return (
		<div className={styles.backdrop} onClick={handleBackdropClick}>
			<div className={styles.modal}>
				<h2 className={styles.title}>Are You Sure You Want To Unlink This Meter?</h2>
				<p className={styles.description}>You will no longer be able to manage this meter from your profile.</p>
				<div className={styles.actions}>
					<button type="button" className={styles.cancelButton} onClick={onClose} disabled={isLoading}>
						Cancel
					</button>
					<button type="button" className={styles.confirmButton} onClick={onConfirm} disabled={isLoading}>
						{isLoading ? <span className={styles.spinner} aria-label="Loading" /> : "Unlink Meter"}
					</button>
				</div>
			</div>
		</div>
	);
};

export default UnlinkConfirmModal;
